import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

interface Props {
   linkFacebook?: string;
   linkInstagram?: string;
}

const LinksRedesSociais: React.FC<Props> = ({ linkFacebook, linkInstagram }: Props) => {
   if (!linkFacebook && !linkInstagram) {
      return <div className="mb-5" />;
   }

   const colSize = (linkFacebook && linkInstagram) ? "6" : "12";

   return (
      <section className="text-center mt-3 mb-3">
         <div>
            <Row
               style={{ margin: '0 auto', maxWidth: '130px', flexWrap: 'nowrap', WebkitFlexWrap: 'nowrap' }}
               noGutters
            >
               {/* Botão Facebook */}
               {linkFacebook ? (
                  <Col xs={colSize} style={{ padding: '0' }}>
                     <div className="mx-2">
                        <a
                           className="uil-facebook icone-redes-sociais-organizador"
                           href={linkFacebook}
                           rel="noopener noreferrer"
                           target="_blank"
                        />
                     </div>
                  </Col>
               ) : null}

               {/* Botão Instagram */}
               {linkInstagram ? (
                  <Col xs={colSize} style={{ padding: '0' }}>
                     <div className="mx-2">
                        <a
                           className="uil-instagram icone-redes-sociais-organizador"
                           href={linkInstagram}
                           rel="noopener noreferrer"
                           target="_blank"
                        />
                     </div>
                  </Col>
               ) : null}
            </Row>
         </div>
      </section>
   );
};

export default LinksRedesSociais;
